export default "__VITE_ASSET__DZ0vXfkr__"